// extracted by mini-css-extract-plugin
module.exports = {"main":"ContentPage_main__NgHEA"};